import { useProjects } from './useProjects';
import { useSelectLandingPageAccess } from '../selectors';
import { STATUS_ENUM } from '../types';
import { useSiteConfig } from '../contexts/SiteConfiguration';
import { getEnvironment } from '../utils';

const envSuffix = {
	LOCAL: 'staging',
	DEV: 'staging',
	QA: 'qa',
	STAGE: 'staging',
	PROD: '',
};

const regionPrefix = {
	US: '',
	EMEA: 'emea',
	AUS: 'aus',
};

export const useLandingPageAccess = () => {
	const { config } = useSiteConfig();
	const { status, isHubAdmin, isTeamAdmin, eligibleTeams, adminHubs } =
		useSelectLandingPageAccess();
	const { isInitialized, isFetching, projects, error } = useProjects();

	const emptyProjects =
		error !== null ||
		(isInitialized && !isFetching && projects.length === 0);
	const accessLoading = status === STATUS_ENUM.PENDING || isFetching;

	const getHubsListUrl = () => {
		let hubListUrl =
			config?.forge?.cpaHubsDomain ??
			'https://manage.autodesk.com/hubs-list';
		if (eligibleTeams?.length === 0) return hubListUrl;

		const oxigenIds = eligibleTeams
			.map(t => t.split('oxygenId:')[1])
			.join(',');
		hubListUrl = `${hubListUrl}?product=info360&teams=${oxigenIds}`;

		return hubListUrl;
	};

	const getCPAUrl = () => {
		const cpaDomain = 'https://cpa.autodesk.com';
		const hub = adminHubs?.[0];

		const env = envSuffix[getEnvironment()] || 'PROD';
		const region = regionPrefix[hub?.hubRegion] || 'US';

		let cpaUrl = cpaDomain;
		if (env !== 'PROD') cpaUrl = cpaUrl.replace('cpa', `cpa-${env}`);
		if (region !== 'US')
			cpaUrl = cpaUrl.replace('autodesk', `${region}.autodesk`);

		const accountId = hub?.accountId;
		return accountId
			? `${cpaUrl}/account-admin/members/accounts/${accountId}`
			: cpaDomain;
	};

	return {
		isHubAdmin,
		isTeamAdmin,
		emptyProjects,
		projectsLoading: isFetching,
		accessLoading,
		getHubsListUrl,
		getCPAUrl,
	};
};
